"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
var tslib_1 = require("tslib");
function gql(literals) {
    var e_1, _a;
    var expressions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        expressions[_i - 1] = arguments[_i];
    }
    var string = '';
    try {
        for (var _b = tslib_1.__values(literals.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), index = _d[0], literal = _d[1];
            string += literal;
            if (index in expressions) {
                // eslint-disable-next-line @typescript-eslint/no-base-to-string
                string += expressions[index];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return string;
}
exports.gql = gql;
//# sourceMappingURL=fakeGqlTag.js.map